import React, { useContext, useState } from 'react';
import c from 'classnames';
import Modal from 'react-modal';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import BurgerIcon from '@wix/da-ds/pkg/Icons/Burger';
import NetworkBar from '../../../NetworkBar';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { BiData, NetworkbarMenuIconBiEvent } from '@wix/da-bi/pkg/events';

import s from './Burger.scss';

export interface Props {
  isBurgerMenuOpen: boolean;
  showNetworkBar?: boolean;
  iconClassName?: string;
  toggleBurgerMenu: (isOpenAfter: boolean) => void;
}

const Burger: React.FC<Props> = ({
  isBurgerMenuOpen,
  toggleBurgerMenu,
  iconClassName,
  showNetworkBar = true,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const [isModalOpenAnimated, setIsModalOpenAnimated] = useState(false);

  return (
    <>
      <IconButton
        size="medium"
        aria-expanded={isBurgerMenuOpen}
        aria-label={t('siteHeader.burger.a11y')}
        aria-controls="burger-menu-networkbar"
        icon={BurgerIcon}
        className={iconClassName}
        onClick={() => {
          yieldToMain(() => {
            toggleBurgerMenu(!isBurgerMenuOpen);
          });
        }}
        biData={BiData<NetworkbarMenuIconBiEvent>({
          evid: 161,
        })}
      />
      {showNetworkBar && (
        <Modal
          isOpen={isBurgerMenuOpen}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          className={c(
            s['modal-root'],
            isMobile && s['modal-root-static-open'],
            isModalOpenAnimated && s['modal-root-animated-open']
          )}
          onAfterOpen={() => {
            setIsModalOpenAnimated(true);
          }}
          overlayClassName={s['overlay']}
          bodyOpenClassName={null}
          onRequestClose={() => {
            setIsModalOpenAnimated(false);
            /* wait for animation to finish to remove the Modal */
            setTimeout(() => {
              toggleBurgerMenu(false);
            }, 300);
          }}
        >
          <NetworkBar
            id="burger-menu-networkbar"
            isVisible={isBurgerMenuOpen}
            className={s['networkbar']}
          />
        </Modal>
      )}
    </>
  );
};
Burger.displayName = 'Burger';

export default Burger;
